import { FC } from 'react'
import { css } from '@emotion/react'
import { Link } from 'gatsby'
import { MyTheme, theme } from '@ui/styles/theme'

type Color = 'primary' | 'white'

type ButtonLinkType = {
  path: string
  text: string
  isExternal?: boolean
  backgroundColor?: Color
  isExpand?: boolean
}

const ButtonLink: FC<ButtonLinkType> = ({
  path,
  text,
  isExternal = false,
  backgroundColor = 'primary'
}) => {
  const styles = createStyles(theme, backgroundColor)

  return isExternal ? (
    <a css={styles.buttonLink} href={path} target="_blank" rel="noreferrer">
      {text}
    </a>
  ) : (
    <Link css={styles.buttonLink} to={path}>
      {text}
    </Link>
  )
}

const createStyles = (theme: MyTheme, backgroundColor: Color) => {
  const isPrimary = backgroundColor === 'primary'
  const background = isPrimary
    ? `linear-gradient(0.25turn, ${theme.colors.primary}, 70%, ${theme.colors.primaryDark})`
    : theme.colors.white

  const color = isPrimary ? theme.colors.white : theme.colors.primary

  const border = isPrimary ? 'none' : `1px solid ${theme.colors.primary}`

  return {
    buttonLink: css`
      display: inline-block;
      padding: 12px 20px;
      background: ${background};
      box-sizing: border-box;
      color: ${color};
      font-size: 14px;
      font-family: Noto Sans JP;
      font-weight: bold;
      border: ${border};
      border-radius: 2px;
      transition: all 0.3s ease;
      text-align: center;
      text-decoration: none;
      &:hover {
        opacity: 0.7;
        text-decoration: none;
      }
    `
  }
}

export default ButtonLink
